export default __webpack_public_path__ + "static/media/general-error@3x.aaf969d9.png";